<template>
    <v-card-text>
        <v-container fluid grid>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <ModalAccesorioAroComponent :objModal="obModalAro" 
                                                :porc_casco_permitir_valor_accesorio_adicional="parametros.porc_casco_permitir_valor_accesorio_adicional_wizard"
                                                :valorCasco="valorCasco"
                    />

                    <ModalAccesorioLlantaComponent :objModal="obModalLlanta" 
                                                   :porc_casco_permitir_valor_accesorio_adicional="parametros.porc_casco_permitir_valor_accesorio_adicional_wizard"
                                                   :valorCasco="valorCasco"
                    />

                    <ModalAccesorioOtroComponent :objModal="obModalOtro" 
                                                 :porc_casco_permitir_valor_accesorio_adicional="parametros.porc_casco_permitir_valor_accesorio_adicional_wizard"
                                                 :valorCasco="valorCasco"
                    />

                    <ModalAccesorioRadioComponent :objModal="obModalRadio" 
                                                  :porc_casco_permitir_valor_accesorio_adicional="parametros.porc_casco_permitir_valor_accesorio_adicional_wizard"
                                                  :valorCasco="valorCasco"
                    />
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-row dense align="center" justify="center">
                        <v-col cols="12" :sm="$root.isTouch ? 12 : 8">
                            <div class="text-center">
                                <h1 :class="$root.isTouch ? 'titleSection title' : 'titleSection'">Agregar Coberturas Adicionales</h1>
                            </div>
                            <div class="text-center mt-3">
                                <p class="contenido" :style="$root.isTouch ? 'text-align:justify':''">
                                    Todos los accesorios de fábrica de tu auto están cubiertos.
                                    Pero si le has colocado algún accesorio especial y más costoso que también deseas
                                    proteger, añádelo aquí.
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="3" class="mt-3" v-for="(v,k) in _.orderBy(listAccesorio,['orden'],['asc'])" :key="k">
                    <div class="text-center" style="position: relative; z-index: 10;">
                        <v-btn class="mx-2" x-small fab dark @click="addAccesorio(v);"
                            :class='v.add ? "addAccesorio" : "removeAccesorio"'>
                            <v-icon dark v-if="v.add">check</v-icon>
                            <v-icon dark v-else>add</v-icon>
                        </v-btn>
                    </div>
                    <div class="text-center" style="position: relative;margin-top: -17px;">
                        <v-img :src="v.icono" contain height="150px" max-height="150px" />
                    </div>
                    <div class="text-center" style="height:70px">
                        <p v-html="v.nombre_accesorio"></p>
                        <p v-show="!_.isNaN(parseFloat(v.valorAsegurado))">
                            <strong>Valor Asegurado</strong><br>
                            <span v-html="`$ ${v.valorAsegurado}`"></span>
                        </p>
                    </div>
                </v-col>
            </v-row>

            <v-row dense class="mt-3 mb-3" align="center" justify="center">
                <v-col cols="12" class="text-center">
                    <v-icon color="secundary" class="btnNext" @click="siguiente">arrow_forward</v-icon>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowAccesoriosComponent',
        inject: ['next', 'updateData','recalcularPrima'],
        components:{
            ModalAccesorioAroComponent    : () => import('../accesorios/ModalAccesorioAroComponent'),
            ModalAccesorioLlantaComponent : () => import('../accesorios/ModalAccesorioLlantaComponent'),
            ModalAccesorioOtroComponent   : () => import('../accesorios/ModalAccesorioOtroComponent'),
            ModalAccesorioRadioComponent  : () => import('../accesorios/ModalAccesorioRadioComponent')
        },
        props: {
            listAccesorioActual: {
                type: Array,
                default: () => []
            },
            listAccesorioNuevo: {
                type: Array,
                default: () => []
            },
            listCoberturaNueva:{
                type: Array,
                default: () => []
            },
            stepper: {
                type: Number
            },
            valorCasco:{
                type:Number,
                default:0
            },
            parametros: {
                type: Object,
                default: {}
            }
        },
        data: () => ({
            listAccesorio: [],
            obModal:{
                abrirModal:false,
                size:'40%',
                titulo:'',
                marca:'',
                rin:'',
                cantidad:'',
                valorAsegurado:'',
                name_factura:'',
                name_foto:'',
                disabled:false
            },
            obModalAro:{},
            obModalLlanta:{},
            obModalOtro:{},
            obModalRadio:{},
        }),
        created() {
            this.$set(this,'listAccesorio',_.cloneDeep(this.listAccesorioNuevo));
            this.resetModal();
        },
        watch: {
            stepper(val) {
                if (val == 4) {
                    this.$set(this,'listAccesorio',_.cloneDeep(this.listAccesorioNuevo));
                    this.resetModal();
                }
            }
        },
        methods: {
            addAccesorio(o){
                this.resetModal();
                var disabled = !_.isUndefined(o.idInclusion) && !_.isNull(o.idInclusion) ? true : false;
                var disabledBtn = o.add ? true : false;

                switch (parseInt(o.id_accesorio)) {
                    case this.parametros.accesorios.id_accesorio_aros_wizard:
                        this.$set(this,'obModalAro',_.merge({},this.obModalAro,o,{abrirModal:true,titulo:o.nombre_accesorio,disabled:disabled,disabledBtn:disabledBtn}));
                        break;                    

                    case this.parametros.accesorios.id_accesorio_llantas_wizard:
                        this.$set(this,'obModalLlanta',_.merge({},this.obModalLlanta,o,{abrirModal:true,titulo:o.nombre_accesorio,disabled:disabled,disabledBtn:disabledBtn}));
                        break;

                    case this.parametros.accesorios.id_accesorio_otros_wizard:
                        this.$set(this,'obModalOtro',_.merge({},this.obModalOtro,o,{abrirModal:true,titulo:o.nombre_accesorio,disabled:disabled,disabledBtn:disabledBtn}));
                        break;

                    case this.parametros.accesorios.id_accesorio_radio_wizard:
                        this.$set(this,'obModalRadio',_.merge({},this.obModalRadio,o,{abrirModal:true,titulo:o.nombre_accesorio,disabled:disabled,disabledBtn:disabledBtn}));
                        break;
                }
            },
            addListAccesorio(o,remove){
                var idCobCasco = this.parametros.id_cobertura_todo_riesgo_wizard;
                var cob = _.find(this.listCoberturaNueva,{'id_cobertura':idCobCasco});
                var casco = _.get(cob,'valor_cobertura',0);
                var t = 0;
                
                return new Promise((resolve,reject)=>{
                                var index = _.findIndex(this.listAccesorio,{'index':o.index});

                                if(!remove){
                                    this.listAccesorio[index] = _.merge({},o,{add:true});
                                    t = casco + o.valorAsegurado;                    
                                }
                                else{
                                    this.listAccesorio[index] = _.merge({},o,{add:false});
                                    t = casco - o.valorAsegurado;                    
                                }

                                this.updateData('objForm.objInfoSeguroRenovacion.accesorios',this.listAccesorio);
                            return resolve(true);
                        })
                        .then((r)=>{
                            if(!r) throw 'Error';
                                if(parseInt(o.genera_solicitud) == 0){
                                    var index = _.findIndex(this.listCoberturaNueva,{'id_cobertura':idCobCasco});
                                    var ob = { valor_cobertura: _.round(t,2), valor_cobertura_n: _.round(t,2) };

                                    this.updateData(`objForm.objInfoSeguroRenovacion.coberturas[${index}]`,ob);
                                    return this.recalcularPrima(false);
                                }
                                else
                                    return true;
                        })
                        .then((r)=>{
                            if(!r) throw 'Error';
                                return true;
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,'E');
                        });
            },
            siguiente() {
                this.updateData('objForm.objInfoSeguroRenovacion.accesorios',this.listAccesorio);
                this.next();
            },
            resetModal(){
                var keys = ['obModalAro','obModalLlanta','obModalOtro','obModalRadio'];
                _.forEach((keys),(v)=>{ 
                    this.$set(this,v,this.obModal);
                });
            }
        },
        provide(){
            return{
                addListAccesorio: this.addListAccesorio
            }
        }
    }
</script>

<style>
    .addAccesorio{
        background-color: #4caf50 !important;
        border-color: #4caf50 !important;
    }
    .removeAccesorio{
        background-color: #EE4637 !important;
        border-color: #EE4637 !important;
    }
</style>